//import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
import CopyBox from '../bbcode/copybox';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../fontawesome/fontawesome';
import Giphy from './giphy';
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import { Rnd } from "react-rnd";
import {consoleLog} from '../../../utils/functions';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import ListGroup from 'react-bootstrap/ListGroup';

import './emojicrew.css';
//import './css/header.css';

const Palette = (props) => {
  const [color, setColor] = useColor(props.color);
  return <ColorPicker width={300} height={200} color={color} onChange={setColor} onChangeComplete={(e) => {props.newColor(e.hex)}} hideInput={["hsv"]}  />;
};

class EmojiCrew extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,

			components: {
				Introduction: false,
				EmojisEmotes: false,
				GiphyTenor: false,
				Messaging: false,
				Handover: false,
				Globe: false,
        Welcome: false,
				Clock: false,
				TrackID: false,
				Alerts: false
			},

      clock: {x: 0, y: 0, width: 0, height: 0},
      giphy: [{x: 0, y: 0, width: 0, height: 0}, {x: 0, y: 0, width: 0, height: 0}, {x: 0, y: 0, width: 0, height: 0}],
      component: [500, 500],
      //giphy: 110,
			
      setting: '',

		};

    this.resizeComponent = this.resizeComponent.bind(this);
    this.setSetting = this.setSetting.bind(this);
    this.setGiphyTenorCount = this.setGiphyTenorCount.bind(this);
    this.setGiphyTenorSettings = this.setGiphyTenorSettings.bind(this);
    this.setClockSettings = this.setClockSettings.bind(this);
    this.setColor = this.setColor.bind(this);
    this.updateComponent = this.updateComponent.bind(this);

    this.playEmoji = this.playEmoji.bind(this);
    this.playGiphy = this.playGiphy.bind(this);
    this.playMessage = this.playMessage.bind(this);
    this.Reboot = this.Reboot.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getAuthentications();
    let params = new URLSearchParams();
    params.append('servicekey', this.props.servicekey);
    const x = await postApi('/v3/template/component', params);
    consoleLog(x.data);
    this.setState({status: true, components: x.data.components},()=>{
      this.resizeComponent();
    });

    window.addEventListener('resize', ()=>this.resizeComponent());

	}

	componentWillUnmount() {
	}

  resizeComponent() {
    let component = document.getElementById('component');
    //let componentmenu = document.getElementById('component-menu');
    //consoleLog(component.offsetWidth, component.offsetHeight, this.state.components.Clock.settings);
    let clock = this.state.clock;
    clock.x = this.state.components.Clock.settings[0][0]*component.offsetWidth;
    clock.y = this.state.components.Clock.settings[0][1]*component.offsetHeight;
    clock.width = this.state.components.Clock.settings[0][2]*component.offsetWidth;
    clock.height = this.state.components.Clock.settings[0][3]*component.offsetHeight;

    let giphy = this.state.giphy;
    for( let i in this.state.components.GiphyTenor.settings ) {
      //consoleLog(this.state.components.GiphyTenor.settings[i]);
      giphy[i].x = this.state.components.GiphyTenor.settings[i][0]*component.offsetWidth;
      giphy[i].y = this.state.components.GiphyTenor.settings[i][1]*component.offsetHeight;
      giphy[i].width = this.state.components.GiphyTenor.settings[i][2]*component.offsetWidth;
      giphy[i].height = this.state.components.GiphyTenor.settings[i][3]*component.offsetHeight;
    }

    this.setState({component: [component.offsetWidth, component.offsetHeight], clock, giphy});
  }

  async setSetting(setting) {
    this.setState({setting});
  }

  playEmoji(style, length) {

    let message = '';
    let selection = ['👋','😪','🔥','🤣','💓','🎉','👌','😁','🔔','🤔','👍','❤','🔊','📣','🙌','🍻','💕','🎧','🤩','🤑','🌭','🎸','♥','🍺','🙏','😥','👊','🥰','⚡','🤞','🧀','💩','😴','😒','📰','😃','⏲','📺','💘','💖'];
    if( length >= 20 ) {
      let random = Math.floor(Math.random() * 10 ) + 20;
      for( let i = 0; i < random; i++ ) message = `${message}${selection[Math.floor(Math.random()*selection.length)]}`;
    } else {
      let random = Math.floor(Math.random() * 10 ) + 1;
      for( let i = 0; i < random; i++ ) message = `${message}${selection[Math.floor(Math.random()*selection.length)]}`;
    }

    let params = new URLSearchParams();
    params.append('service', this.props.service);
    params.append('servicekey', this.props.servicekey);
    if( style ) params.append('style', style);
    params.append('message', message);
    const value = this.context;
    postApi(`${value.worker[this.props.service]}/v3/emojicrew/testing`, params);
  }

  playGiphy = (url) => {
		document.body.click();
    let params = new URLSearchParams();
    params.append('service', this.props.service);
    params.append('servicekey', this.props.servicekey);
    params.append('template', 'giphytenor');
    params.append('message', `https://media.giphy.com/media/${url}/giphy.gif`);
    const value = this.context;
    postApi(`${value.worker[this.props.service]}/v3/emojicrew/testing`, params);
	}

  playMessage() {
    let message = document.getElementById('playMessage').value;
    
    if( message === '' ) return;

    
    document.getElementById('playMessage').value = '';

    

    let params = new URLSearchParams();
    params.append('service', this.props.service);
    params.append('servicekey', this.props.servicekey);
    params.append('template', 'message');
    params.append('message', message);
    const value = this.context;
    postApi(`${value.worker[this.props.service]}/v3/emojicrew/testing`, params);
  }


  setGiphyTenorCount(value) {
    let components = this.state.components;
    if( components.GiphyTenor.settings.length !== value ) {
      if( value < components.GiphyTenor.settings.length ) {
        components.GiphyTenor.settings = components.GiphyTenor.settings.splice(0, value);
      } else {
        for( let i = 0; i < value; i++ ) {
          if( !components.GiphyTenor.settings[i] ) {
            switch(i) {
              case 1:
                components.GiphyTenor.settings[i] = [(1280/2)/1280-150/1280, (720-50)/720-180/720, 300/1280, 180/720];
              break;
              case 2:
                components.GiphyTenor.settings[i] = [50/1280, (720-50)/720-180/720, 300/1280, 180/720];
              break;
              default:
              break;
            }
          }
        }
      }
      this.setState({components},()=>{
        this.updateComponent('GiphyTenor', 'settings', components.GiphyTenor.settings);
      });
    }
  }

  setGiphyTenorSettings(index) {

    /*let giphy = {...this.state.giphy};
    giphy[index].x = giphy[index].x / this.state.component[0];
    giphy[index].y = giphy[index].y / this.state.component[1];
    
    giphy[index].width = giphy[index].width / this.state.component[0];
    giphy[index].height = giphy[index].height / this.state.component[1];*/
    //consoleLog(giphy);

    let array = [];
    for( let i in this.state.components.GiphyTenor.settings ) {
      //consoleLog(this.state.giphy[i]);
      array.push([
        this.state.giphy[i].x / this.state.component[0],
        this.state.giphy[i].y / this.state.component[1],
        this.state.giphy[i].width / this.state.component[0],
        this.state.giphy[i].height / this.state.component[1]
      ]);
    }
    //consoleLog(array);

    this.updateComponent('GiphyTenor', 'settings', array);

  }

  setClockSettings() {
    //consoleLog(this.state.component);

    let clock = {...this.state.clock};
    clock.x = clock.x / this.state.component[0];
    clock.y = clock.y / this.state.component[1];
    
    clock.width = clock.width / this.state.component[0];
    clock.height = clock.height / this.state.component[1];
    //consoleLog(clock);
    this.updateComponent('Clock', 'settings', [[clock.x,clock.y,clock.width,clock.height]]);

  }

  setColor(value) {
    this.updateComponent('Clock', 'color', value)
  }


  async updateComponent(component, setting, value) {
    let components = this.state.components;
    components[component][setting] = value;
    this.setState({components},()=>{
      let params = new URLSearchParams();
      params.append('servicekey', this.props.servicekey);
      params.append('component', component);
      params.append('setting', setting);
      params.append('value', JSON.stringify(value));
      putApi('/v3/template/component', params);
    });
  }

  async Reboot() {
    let params = new URLSearchParams();
    params.append('servicekey', this.props.servicekey);
    params.append('reboot', 1);
    await postApi('/v3/server/reboot', params);
  }

	render() {

		
		const components = Object.keys(this.state.components).map((e,i) => {
      if( this.state.components[e] !== false ) {
        return (
          <Nav.Item key={i} onClick={()=>this.setSetting(e)}>
						<Nav.Link eventKey={e}>{e==='EmojisEmotes'?'Emojis / Emotes':e==='GiphyTenor'?'Giphy / Tenor':e}</Nav.Link>
					</Nav.Item>
        )
			} else {
        return (<React.Fragment key={i}></React.Fragment>)
      }
		});
		

    const emojisemotes = Object.keys(this.state.components.EmojisEmotes).map((e,i) => {
      return (
        <ListGroup.Item key={i}>
        
          {e}<br />
          {this.state.components.EmojisEmotes[e].map((f,j) => {
            return (
              <Button key={j} size="sm" variant="success" onClick={()=>this.playEmoji(f, i===2?20:0)}>{f}</Button>
            )})
          }
          <Dropdown.Divider />
        
        </ListGroup.Item>
      )
		});
    

    const giphytenorvariant = this.state.components.GiphyTenor.variant && this.state.components.GiphyTenor.variant.map((e,i) => {
      return (
        <option key={i} value={this.state.components.GiphyTenor.variant[e]} onClick={()=>this.updateComponent('GiphyTenor', 'modal', e)}>{e==='false'?'Disable':e}</option>
      )
		});


    const messagingvariant = this.state.components.Messaging.variant && this.state.components.Messaging.variant.map((e,i) => {
      return (
        <option key={i} value={this.state.components.Messaging.variant[e]} onClick={()=>this.updateComponent('Messaging', 'modal', e)}>{e==='false'?'Disable':e}</option>
      )
		});


    const welcomevariant = this.state.components.Welcome.variant && this.state.components.Welcome.variant.map((e,i) => {
      return (
        <option key={i} value={this.state.components.Welcome.variant[e]} onClick={()=>this.updateComponent('Welcome', 'modal', e)}>{e==='false'?'Disable':e}</option>
      )
		});


    const clockvariant = this.state.components.Clock.variant && this.state.components.Clock.variant.map((e,i) => {
      return (
        <option key={i} value={this.state.components.Clock.variant[e]} onClick={()=>this.updateComponent('Clock', 'modal', e)}>{e==='false'?'Disable':e}</option>
      )
		});


    //---- Components
    const giphytenorcomponent = this.state.components.GiphyTenor.settings && this.state.components.GiphyTenor.settings.map((e,i) => {
      return (
        <React.Fragment key={i}>
          <Rnd
            style={{display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `dashed 2px #FF0000`,}}
            bounds={'parent'}
            size={{ width: this.state.giphy[i].width, height: this.state.giphy[i].height }}
            position={{ x: this.state.giphy[i].x, y: this.state.giphy[i].y }}
            onDragStop={(e, d) => {
              let giphy = this.state.giphy;
              giphy[i].x = d.x;
              giphy[i].y = d.y;
              this.setState({ giphy },()=>this.setGiphyTenorSettings(i));
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
              let giphy = this.state.giphy;
              giphy[i].x = position.x;
              giphy[i].y = position.y;
              giphy[i].width = parseInt(ref.style.width.replace('px',''));
              giphy[i].height = parseInt(ref.style.height.replace('px',''));
              this.setState({giphy},()=>this.setGiphyTenorSettings(i));
            }}
          ></Rnd>
          {/*<div key={i} style={{position: 'absolute', left: e[0]*this.state.component[0], top: e[1]*this.state.component[1], width: e[2]*this.state.component[0], height: e[3]*this.state.component[1], border: `1px solid #ff0000`}}></div>*/}
        </React.Fragment>
      )
		});


    const messagingcomponent = this.state.components.Messaging.settings && this.state.components.Messaging.modal === 'Live Feed' && this.state.components.Messaging.settings.map((e,i) => {
      return (
        <div key={i} style={{position: 'absolute', left: e[0]*this.state.component[0], top: e[1]*this.state.component[1], width: e[2]*this.state.component[0], height: e[3]*this.state.component[1], border: `1px solid #ff0000`}}></div>
      )
		});


    const clockcomponent = this.state.components.Clock.settings && this.state.components.Clock.settings.map((e,i) => {
      return (
        <Rnd
          style={{display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: `dashed 2px #FF0000`,}}
          bounds={'parent'}
          size={{ width: this.state.clock.width, height: this.state.clock.height }}
          position={{ x: this.state.clock.x, y: this.state.clock.y }}
          onDragStop={(e, d) => {
            let clock = this.state.clock;
            clock.x = d.x;
            clock.y = d.y;
            this.setState({ clock },()=>this.setClockSettings());
          }}
          onResizeStop={(e, direction, ref, delta, position) => {
            let clock = this.state.clock;
            clock.x = position.x;
            clock.y = position.y;
            clock.width = parseInt(ref.style.width.replace('px',''));
            clock.height = parseInt(ref.style.height.replace('px',''));
            this.setState({clock},()=>this.setClockSettings());
          }}
        ></Rnd>
      )
      /*<div key={i} style={{position: 'absolute', left: e[0]*this.state.component[0], top: e[1]*this.state.component[1], width: e[2]*this.state.component[0], height: e[3]*this.state.component[1], border: `1px solid #ff0000`, color: this.state.components.Clock.color}} className="Clock">
          {/*moment().format("dddd, MMMM Do YYYY h:mm A")*}
        </div>*/
		});
		
		return (
			<>
				{this.state.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
                <Col xl={12}>
                  <div className="card custom-card">
                    <div className="d-flex p-3 border-bottom-0">
                      <div className="">
                        <svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
                      </div>
                      <div className="mt-0 text-start">
                        <span className="fs-14 fw-semibold">OBS / Streamlabs Browser Template</span>
                        <p className="fs-13 text-muted mb-0">Here you will find details on how to connect your template along with testing.</p>
                      </div>
                      
                    </div>
                  </div>
                  <div className="card custom-card custom-frame">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
                        EmojiCrew Template
                      </div>
                    </div>
                    <div className="card-body">
                      <Row className="custom-frame-div">

                        <Col xs={12}>
                          <Nav variant="pills" defaultActiveKey="/home">
														{components}
                          </Nav>
                        </Col>
                        
                        <Col xs={12} className="custom-frame-div">
                          <div className="custom-frame-div-iframe">
                            <iframe src={`https://cloud1.ultrastream.io:3000/${this.props.servicekey}`} className="iframe" height="100%" title="Emojicrew" />
                            <div id="component" className="custom-frame-div-component">

                              {this.state.setting === '' &&
                                <></>
                              }

                              {this.state.setting === 'Introduction' &&
                                <></>
                              }

                              {this.state.setting === 'EmojisEmotes' &&
                                <></>
                              }

                              {this.state.setting === 'GiphyTenor' &&
                                <>
                                  {this.state.components.GiphyTenor.modal !== 'false' &&
                                    <>
                                      {giphytenorcomponent}
                                    </>
                                  }
                                </>
                              }

                              {this.state.setting === 'Messaging' &&
                                <>
                                  {this.state.components.Messaging.modal !== 'false' &&
                                    <>
                                      {messagingcomponent}
                                    </>
                                  }
                                </>
                              }

                              {this.state.setting === 'Clock' &&
                                <>
                                  {clockcomponent}
                                </>
                              }

                              {this.state.setting === 'Globe' &&
                                <></>
                              }

                              {this.state.setting === 'TrackID' &&
                                <>
                                  <div className="TrackID-NP2">
                                    <h4>Supported TrackID Software</h4>
                                    <p>
                                      Support your live audience by providing trackID information with !trackid in the comments<br /><br />
                                      Now Playing 2<br />
                                      Unboxed<br />
                                    </p>
                                  </div>

                                </>
                              }

                              {this.state.setting === 'Alerts' &&
                                <></>
                              }

                            </div>
                          </div>
                          <div id="component-menu" className="custom-frame-div-menu">
                            
                            {this.state.setting === '' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Stream Template</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                              </ListGroup>
                            }

                            {this.state.setting === 'Introduction' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Introduction</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                              </ListGroup>
                            }

                            {this.state.setting === 'EmojisEmotes' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Emojis / Emotes</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                                <ListGroup.Item>
                                  <Dropdown className="d-inline mx-1" drop="up">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
                                      Animate
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </ListGroup.Item>
                                {emojisemotes}
                              </ListGroup>
                            }

                            {this.state.setting === 'GiphyTenor' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Giphy / Tenor</strong></ListGroup.Item>
                                <ListGroup.Item>Rotation order</ListGroup.Item>
                                <ListGroup.Item>
                                  <Form.Select aria-label="Default select example" defaultValue={this.state.components.GiphyTenor.modal}>
                                    {giphytenorvariant}
                                  </Form.Select>
                                </ListGroup.Item>
                                {this.state.components.GiphyTenor.modal !== 'false' &&
                                  <>
                                    <ListGroup.Item>Number of Giphy / Tenor elements</ListGroup.Item>
                                    <ListGroup.Item>
                                      <Form.Select aria-label="Default select example" defaultValue={this.state.components.GiphyTenor.settings.length}>
                                        <option value={1} onClick={()=>this.setGiphyTenorCount(1)}>One</option>
                                        <option value={2} onClick={()=>this.setGiphyTenorCount(2)}>Two</option>
                                        <option value={3} onClick={()=>this.setGiphyTenorCount(3)}>Three</option>
                                      </Form.Select>
                                    </ListGroup.Item>
                                    <ListGroup.Item style={{position: 'relative'}}>
                                      <Giphy width={110} selectUrl={this.playGiphy} />
                                    </ListGroup.Item>
                                  </>
                                }
                              </ListGroup>
                            }

                            {this.state.setting === 'Messaging' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Messaging</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                                <ListGroup.Item>
                                  <Form.Select aria-label="Default select example" defaultValue={this.state.components.Messaging.modal}>
                                    {messagingvariant}
                                  </Form.Select>
                                </ListGroup.Item>
                                {this.state.components.Messaging.modal !== 'false' &&
                                  <>
                                    <ListGroup.Item>Animate Chat</ListGroup.Item>
                                    <ListGroup.Item>
                                      <InputGroup className="mb-3">
                                        <Form.Control
                                          placeholder="Send message"
                                          aria-label="Send message"
                                          aria-describedby="basic-addon2"
                                          id="playMessage"
                                        />
                                        <Button variant="outline-secondary" id="button-addon2" onClick={()=>this.playMessage()}>
                                          Send
                                        </Button>
                                      </InputGroup>
                                    </ListGroup.Item>
                                  </>
                                }
                              </ListGroup>
                            }

                            {this.state.setting === 'Welcome' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Welcome</strong></ListGroup.Item>
                                <ListGroup.Item>Please select clock type</ListGroup.Item>
                                <ListGroup.Item>
                                  <Form.Select aria-label="Default select example" defaultValue={this.state.components.Welcome.modal}>
                                    {welcomevariant}
                                  </Form.Select>
                                </ListGroup.Item>
                                {/*this.state.components.Clock.modal !== 'false' &&
                                  <>
                                    <ListGroup.Item>
                                      Color Picker
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Palette color={this.state.components.Clock.color} newColor={this.setColor} />
                                    </ListGroup.Item>
                                  </>
                                */}
                              </ListGroup>
                            }

                            {this.state.setting === 'Clock' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Clock</strong></ListGroup.Item>
                                <ListGroup.Item>Please select clock type</ListGroup.Item>
                                <ListGroup.Item>
                                  <Form.Select aria-label="Default select example" defaultValue={this.state.components.Clock.modal}>
                                    {clockvariant}
                                  </Form.Select>
                                </ListGroup.Item>
                                {this.state.components.Clock.modal !== 'false' &&
                                  <>
                                    <ListGroup.Item>
                                      Color Picker
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Palette color={this.state.components.Clock.color} newColor={this.setColor} />
                                    </ListGroup.Item>
                                  </>
                                }
                              </ListGroup>
                            }

                            {this.state.setting === 'Globe' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Globe</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                              </ListGroup>
                            }

                            {this.state.setting === 'TrackID' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>TrackID</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                              </ListGroup>
                            }

                            {this.state.setting === 'Alerts' &&
                              <ListGroup>
                                <ListGroup.Item className="bg-primary text-white"><strong>Alerts</strong></ListGroup.Item>
                                <ListGroup.Item>Please select one of the menu items to get started</ListGroup.Item>
                              </ListGroup>
                            }
                            
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>

                

                {/*<Col xl={12}>
                  <div className="card custom-card">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
                        Reboot Service
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="">
                        <button type="button" className="btn btn-primary label-btn rounded-pill" onClick={()=>this.Reboot()}><span className="ri-chat-smile-line label-btn-icon me-2 rounded-pill"><FontAwesomeIcon icon="play" /></span>Reboot</button>
                      </div>
                    </div>
                  </div>
                </Col>*/}

                <Col xl={12}>
                  <div className="card custom-card">
                    <div className="card-header">
                      <div className="card-title">OBS Browser Template Details</div>
                    </div>
                    <div className="card-body">
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">URL</label>
                        </div>
                        <div className="col-md-8">
                          <CopyBox content={`https://template.ultrastream.io/${this.props.servicekey}`} />
                        </div>
                      </Row>
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">Width</label>
                        </div>
                        <div className="col-md-4">
                          Set to your video output stream width.
                        </div>
                      </Row>
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">Height</label>
                        </div>
                        <div className="col-md-4">
                          Set to your video output stream height.
                        </div>
                      </Row>
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">Refresh Browser</label>
                        </div>
                        <div className="col-md-4">
                          <input className="form-check-input" type="checkbox" value="" checked="true" /> Refresh browser when source becomes active
                        </div>
                      </Row>
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">Page Permissions</label>
                        </div>
                        <div className="col-md-4">
                          Minimum: Read access to OBS status information
                        </div>
                      </Row>
                      <Row className="pb-3">
                        <div className="col-md-2">
                          <label className="">Advanced - Sources</label>
                        </div>
                        <div className="col-md-4">
                          <input className="form-check-input" type="checkbox" value="" checked="true" /> Enable Browser Source Hardware Acceleration
                        </div>
                      </Row>
                    </div>
                  </div>
                </Col>
                
              </Row>
            </div>
					</div>
				}
			</>
		);
	}
}

export default EmojiCrew;